// api/settings/roleManager.js
import axiosInstance from "../axiosInstance";

// const base = `${process.env.REACT_APP_API_URL || "http://localhost:3001/api"}`;
// const BASE_URL = `${base}/roles`;

const BASE_URL = "/settings/roles";

export const getRoles = () => axiosInstance.get(BASE_URL);

export const createRole = (data) => axiosInstance.post(BASE_URL, data);

export const updateRole = (id, data) => axiosInstance.put(`${BASE_URL}/${id}`, data);

export const deleteRole = (id) => axiosInstance.delete(`${BASE_URL}/${id}`);
